import React, { memo } from 'react';
import { ISvgProps } from './Svg.types';

const Svg = memo<ISvgProps>(({ children, onClick, id, className, width, height, ...props }) => (
  <svg
    data-testid="Svg"
    width={width}
    height={height}
    version="1.1"
    onClick={onClick}
    id={id}
    className={className}
    {...props}
  >
    {children}
  </svg>
));

Svg.displayName = 'Svg';

export default Svg;
